import { CoeDataAnalysisPackageConfigUIModel } from "src/store/models/ui/coeDataAnalysisPackageConfig/coeDataAnalysisPackageConfig";
import { CoeDataAnalysisPackageConfigTableUIModel } from "src/store/models/ui/coeDataAnalysisPackageConfig/coeDataAnalysisPackageConfigTable";

export const encooCoeDataAnalysisPackageConfigUIModels = {
  coeDataAnalysisPackageConfigTable: CoeDataAnalysisPackageConfigTableUIModel,
  coeDataAnalysisPackageConfig: CoeDataAnalysisPackageConfigUIModel,
};
